import { render, staticRenderFns } from "./ActivityTypeCreate.vue?vue&type=template&id=2bb94ab1&scoped=true&"
import script from "./ActivityTypeCreate.vue?vue&type=script&lang=js&"
export * from "./ActivityTypeCreate.vue?vue&type=script&lang=js&"
import style0 from "./ActivityTypeCreate.vue?vue&type=style&index=0&id=2bb94ab1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb94ab1",
  null
  
)

export default component.exports